module.exports = __webpack_public_path__ + "41061eba6355706dfaa9b0d06ba10d09.svg";